import React from 'react';

/**
 * Catches render-time crashes in the program page subtree and shows the
 * error inline instead of unmounting the whole app to a blank screen.
 */
class ProgramErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error('[Programs] render crash:', error, info?.componentStack);
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <div className="program-inner__error">
          <strong>Program page failed to render</strong>
          {'\n\n'}
          {error?.message || String(error)}
          {'\n\n'}
          {error?.stack}
        </div>
      );
    }

    return children;
  }
}

export default ProgramErrorBoundary;
